import { MEMBRESIA_GENERICA } from "../lib/productosPlus";

// Sello visual de lo pagado. Usar en menú, paywall y chips de funciones. El
// identificador conserva el nombre viejo a propósito. `nombre` es el de la
// membresía de la que se habla (nombreMembresia(profile), o TIER_NOMBRE donde
// se ofrece Estudiante Plus); sin él dice "Membresía", la palabra de los
// Términos, que es verdad para cualquier producto.
//
// Forma "Credencial" (Sebastián eligió la B entre tres maquetas el
// 2026-10-17, docs/pitch/preview-sellos-membresia/): rótulo violeta lleno con
// el nombre en letra normal. Sin estrella ni mayúsculas: la versión anterior
// parecía un anuncio. El texto va en `text-paper`, no `text-white`, porque en
// oscuro el violeta es claro y el papel oscuro.
// size: 'xs' = inline/compacto | 'sm' = default | 'md' = destacado
export default function PlusBadge({ size = 'sm', className = '', nombre = MEMBRESIA_GENERICA }) {
  const sizes = {
    xs: 'px-1.5 py-px text-11px',
    sm: 'px-2 py-0.5 text-11px',
    md: 'px-2.5 py-1 text-small',
  };
  return (
    <span
      className={`inline-flex items-center rounded-tk-sm bg-plus text-paper font-sans font-semibold leading-tight whitespace-nowrap ${sizes[size] ?? sizes.sm} ${className}`}
      aria-label={nombre}
    >
      {nombre}
    </span>
  );
}
